(function () {
  var STORAGE_KEY = 'mandira_wishlist_v1';
  var OUTLINE =
    'M7.23214 0C6.31027 0 5.50313 0.416348 5 1.12011C4.49688 0.416348 3.68973 0 2.76786 0C2.03403 0.000868675 1.33049 0.307413 0.8116 0.852381C0.292705 1.39735 0.000827115 2.13623 0 2.90694C0 6.18896 4.63348 8.84552 4.8308 8.95524C4.88281 8.98462 4.94094 9 5 9C5.05906 9 5.11719 8.98462 5.1692 8.95524C5.36652 8.84552 10 6.18896 10 2.90694C9.99917 2.13623 9.70729 1.39735 9.1884 0.852381C8.66951 0.307413 7.96597 0.000868675 7.23214 0ZM5 8.19568C4.18482 7.69682 0.714286 5.42425 0.714286 2.90694C0.714994 2.33516 0.93158 1.78701 1.31655 1.3827C1.70151 0.97839 2.22343 0.750921 2.76786 0.750177C3.63616 0.750177 4.36518 1.23592 4.66964 2.0161C4.69655 2.0849 4.74232 2.14374 4.80115 2.18515C4.85997 2.22656 4.92919 2.24867 5 2.24867C5.07082 2.24867 5.14003 2.22656 5.19885 2.18515C5.25768 2.14374 5.30345 2.0849 5.33036 2.0161C5.63482 1.23451 6.36384 0.750177 7.23214 0.750177C7.77657 0.750921 8.29849 0.97839 8.68345 1.3827C9.06842 1.78701 9.28501 2.33516 9.28571 2.90694C9.28571 5.4205 5.81429 7.69635 5 8.19568Z';
  var SOLID =
    'M7.23214 0C6.31027 0 5.50313 0.416348 5 1.12011C4.49688 0.416348 3.68973 0 2.76786 0C2.03403 0.000868675 1.33049 0.307413 0.8116 0.852381C0.292705 1.39735 0.000827115 2.13623 0 2.90694C0 6.18896 4.63348 8.84552 4.8308 8.95524C4.88281 8.98462 4.94094 9 5 9C5.05906 9 5.11719 8.98462 5.1692 8.95524C5.36652 8.84552 10 6.18896 10 2.90694C9.99917 2.13623 9.70729 1.39735 9.1884 0.852381C8.66951 0.307413 7.96597 0.000868675 7.23214 0Z';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('mandira:wishlist-change', { detail: { items: list } }));
  }

  function has(id) {
    var key = String(id);
    return read().some(function (item) {
      return String(item.id) === key;
    });
  }

  function add(item) {
    var list = read().filter(function (entry) {
      return String(entry.id) !== String(item.id);
    });
    list.unshift(item);
    write(list);
  }

  function remove(id) {
    write(
      read().filter(function (entry) {
        return String(entry.id) !== String(id);
      }),
    );
  }

  function toggle(item) {
    if (has(item.id)) {
      remove(item.id);
      return false;
    }
    add(item);
    return true;
  }

  function setButtonActive(btn, active) {
    btn.classList.toggle('catalog-wishlist-btn--active', active);
    btn.classList.toggle('product-gallery-wishlist--active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    if (btn.classList.contains('cart-page-favourites')) {
      btn.textContent = active ? 'Saved to favourites' : 'Add to favourites';
    } else if (btn.classList.contains('line-wishlist')) {
      btn.textContent = active ? 'Saved to Wishlist' : 'Add to Wishlist';
    }
    var path = btn.querySelector('[data-wishlist-path]');
    if (!path) return;
    path.setAttribute('d', active ? SOLID : OUTLINE);
    if (active) {
      path.removeAttribute('fill-rule');
      path.removeAttribute('clip-rule');
    } else {
      path.setAttribute('fill-rule', 'evenodd');
      path.setAttribute('clip-rule', 'evenodd');
    }
  }

  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      variantId: btn.getAttribute('data-variant-id'),
      title: btn.getAttribute('data-product-title') || '',
      image: btn.getAttribute('data-product-image') || '',
      url: btn.getAttribute('data-product-url') || '',
      priceText:
        btn.getAttribute('data-wishlist-price') ||
        btn.getAttribute('data-product-price') ||
        '',
    };
  }

  function bindButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      if (btn.getAttribute('data-wishlist-bound') === 'true') return;
      btn.setAttribute('data-wishlist-bound', 'true');
      var id = btn.getAttribute('data-product-id');
      if (id) setButtonActive(btn, has(id));
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var item = itemFromButton(btn);
        if (!item.id) return;
        var active = toggle(item);
        setButtonActive(btn, active);
      });
    });
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (id) setButtonActive(btn, has(id));
    });
    var countEl = document.querySelector('[data-wishlist-count]');
    if (countEl) {
      var n = read().length;
      countEl.textContent = String(n);
      countEl.hidden = n < 1;
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var items = read();

    if (!items.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (!grid) return;

    grid.innerHTML = items
      .map(function (item) {
        var href = escapeHtml(item.url || '/products/' + item.handle);
        var img = item.image
          ? '<img src="' +
            escapeHtml(item.image) +
            '" alt="' +
            escapeHtml(item.title) +
            '" class="catalog-product-image" loading="lazy" width="504" height="773">'
          : '<div class="catalog-product-placeholder" role="img" aria-label="No image"><span>No image</span></div>';
        return (
          '<article class="catalog-product-card wishlist-card" data-wishlist-id="' +
          escapeHtml(item.id) +
          '">' +
          '<div class="catalog-product-media">' +
          '<a class="catalog-product-image-link" href="' +
          href +
          '">' +
          img +
          '</a>' +
          '<button type="button" class="catalog-wishlist-btn catalog-wishlist-btn--active" aria-label="Remove from wishlist" aria-pressed="true" data-wishlist-remove="' +
          escapeHtml(item.id) +
          '">' +
          '<svg class="wishlist-icon" width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="' +
          SOLID +
          '" fill="currentColor"></path></svg>' +
          '</button>' +
          '</div>' +
          '<a class="catalog-product-card-link" href="' +
          href +
          '">' +
          '<div class="catalog-product-info">' +
          '<h3 class="catalog-product-title" title="' +
          escapeHtml(item.title) +
          '">' +
          escapeHtml(item.title) +
          '</h3>' +
          '<p class="catalog-product-price">' +
          escapeHtml(item.priceText) +
          '</p>' +
          '</div>' +
          '</a>' +
          '<div class="wishlist-card-actions">' +
          (item.variantId
            ? '<button type="button" class="wishlist-card-atc" data-wishlist-atc="' +
              escapeHtml(item.variantId) +
              '">Add to cart</button>'
            : '<span></span>') +
          '<button type="button" class="wishlist-card-remove" data-wishlist-remove="' +
          escapeHtml(item.id) +
          '">Remove</button>' +
          '</div>' +
          '</article>'
        );
      })
      .join('');


    grid.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        remove(btn.getAttribute('data-wishlist-remove'));
        renderPage();
        syncAllButtons();
      });
    });

    grid.querySelectorAll('[data-wishlist-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-wishlist-atc');
        if (!variantId) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart error');
            return res.json();
          })
          .then(function () {
            btn.textContent = 'Added';
            document.dispatchEvent(new CustomEvent('mandira:cart-updated'));
            if (window.MandiraCartDrawer && typeof window.MandiraCartDrawer.open === 'function') {
              window.MandiraCartDrawer.open();
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Add to cart';
          });
      });
    });
  }

  window.MandiraWishlist = {
    read: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    bindButtons: bindButtons,
    syncAllButtons: syncAllButtons,
    renderPage: renderPage,
  };

  function init() {
    bindButtons(document);
    syncAllButtons();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('mandira:wishlist-change', function () {
    syncAllButtons();
  });
})();
